
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'test',
	'visualizationSlideoutTitle': 'Vizualizări',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Introduceţi un număr',
	'maxValuePlaceholder': 'Introduceţi un număr',
	'customRangeErrorMessage': 'Valoarea trebuie să fie un număr',
	'propFillColor': 'Culoare de umplere',
	'propBorderColor': 'Culoare bordură',
	'propColorPalette': 'Paletă de culori curentă',
	'propColorPaletteChangeLabel': 'Modificare paletă de culori',
	'propNewColorPaletteLabel': 'Creare paletă de culoare personalizată',
	'propNewHeatPaletteLabel': 'Creare paletă de căldură personalizată',
	'propDonutRadius': 'Rază tor',
	'showTitleLabel': 'Afişare titlu',
	'titleTypeLabel': 'Tip titlu',
	'smartTitleLabel': 'Titlu inteligent',
	'customTitleLabel': 'Titlu personalizat',
	'noTitleLabel': 'Fără titlu',
	'propHeatScalePalette': 'Paletă de căldură curentă',
	'propHeatPaletteChangeLabel': 'Modificare paletă de căldură',
	'propMaintainAxisScales': 'Menţinere scală pe axă',
	'propLineAndSymbolColor': 'Culoare linie şi simbol',
	'propLineAndSymbolPalette': 'Paletă culori linie şi simbol',
	'propElementColor': 'Culoare element',
	'propColumnColor': 'Culoare coloană',
	'propColumnPalette': 'Paletă culori coloane',
	'propColumnHeatPalette': 'Paletă termică coloană',
	'propBarColor': 'Culoare bară',
	'propGoalColor': 'Culoare Ţintă',
	'propToColor': 'Culoare La',
	'propFromColor': 'Culoare De la',
	'propNumberValidationErrorMessageId': 'Introduceţi un număr',
	'fontSizeAuto': 'Automat',
	'propAutoBinCount': 'Număr de grupuri',
	'propAutoBinToggle': 'Grupare automată',
	'tabName_general': 'General',
	'tabName_visDetails': 'Detalii',
	'tabName_animation': 'Animaţie',
	'tabName_mediaDetails': 'Detalii de mediu',
	'tabName_webDetails': 'Detalii pagină de Web',
	'tabName_imageDetails': 'Detalii imagine',
	'tabName_visualization': 'Vizualizare',
	'tabName_text': 'Text',
	'sectionName_colorsAndThemes': 'Culoare şi teme',
	'sectionName_appearance': 'Aspect',
	'sectionName_general': 'General',
	'sectionName_colorPalette': 'Culoare',
	'sectionName_axis': 'Axă',
	'sectionName_axis_label': 'Axă',
	'sectionName_legend': 'Legendă',
	'sectionName_chart': 'Diagramă',
	'sectionName_regionLayer': 'Strat regiuni',
	'sectionName_pointLayer': 'Strat puncte',
	'sectionName_latLongLayer': 'Strat latitudine/longitudine',
	'sectionName_pathLayer': 'Strat cale',
	'sectionName_xAxis': 'Axa X',
	'sectionName_yAxis': 'Axa Y',
	'sectionName_xAxis_title': 'Titlu axa X',
	'sectionName_yAxis_title': 'Titlu axa Y',
	'sectionName_xAxis_label': 'Etichetă axa X',
	'sectionName_yAxis_label': 'Etichetă axa Y',
	'sectionName_column_yAxis': 'Axa Y coloană',
	'sectionName_column_yAxis_label': 'Etichetă axa Y coloană',
	'sectionName_column_yAxis_title': 'Titlu axa Y coloană',
	'sectionName_line_yAxis': 'Axa Y linie',
	'sectionName_line_yAxis_label': 'Etichetă axa Y linie',
	'sectionName_line_yAxis_title': 'Titlu axa Y linie',
	'sectionName_title': 'Titlu',
	'sectionName_dataValueLabels': 'Etichete valoare date',
	'sectionName_style': 'Stil',
	'propTransparencyDescription': 'Faceţi obiectul mai transparent sau mai puţin transparent. Introduceţi o valoare între 0 şi 100',
	'smart_annotation_unauthorized': 'Adnotări: acces neautorizat',
	'smart_annotation_method': 'Adnotări: metoda nu este permisă',
	'smart_annotation_media': 'Adnotări: tipul de mediu nu este permis',
	'smart_annotation_input': 'Adnotări: intrare invalidă',
	'smart_annotation_internal': 'Adnotări: eroare de sistem internă',
	'smart_annotation_generic_error': 'Adnotări: eroare de serviciu',
	'smart_annotation_dialog_title': 'Insight-uri',
	'smart_annotation_Show_Insights': 'Afişare insight-uri',
	'smart_annotation_Relationship': 'Relaţia este',
	'forecast_enter_number': 'Introduceţi un număr între ',
	'and': ' şi ',
	'smart_errors': 'Erori de adnotare:',
	'smart_warnings': 'Avertismente de adnotare:',
	'smart_annotation_insight_icon_title': 'Insight-uri',
	'smart_annotations_toggle_on': 'Activare insight-uri',
	'smart_annotations_toggle_off': 'Dezactivare insight-uri',
	'smart_annotation_toggle_on': 'Comutare pe activ',
	'smart_annotation_toggle_off': 'Comutare pe inactiv',
	'smart_annotation_insight_unavailable': 'Insight-urile nu sunt disponibile curent',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Insight-urile nu sunt disponibile când este aplicat un filtru % Sus sau Jos',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Previziunea nu este disponibilă când este aplicat un filtru % Sus sau Jos',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Insight-urile nu sunt disponibile când este aplicat un filtru sus sau jos şi există mai mult de o coloană în câmp',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Previziunea nu este disponibilă când este aplicat un filtru sus sau jos şi există mai mult de o coloană în câmp',
	'forecast_title': 'Previziune',
	'forecast_show': 'Afişare previziune',
	'forecast_toggle_on': 'Activare previziune',
	'forecast_toggle_off': 'Dezactivare previziune',
	'statDetailsPerspectiveTitle': 'Analiză',
	'emptyStatDetailsPanel': 'Nu este disponibilă o analiză suplimentară pentru vizualizarea curentă.',
	'predict_errors': 'Erori analiză',
	'predict_warnings': 'Avertismente analiză',
	'fpd_invalid_data_source': 'Această sursă de date nu are asociat un modul inteligent',
	'fpd_network_issue': 'A apărut o problemă la realizarea analizei pentru această sursă de date',
	'fpd_data_source_category': 'Lipsă module inteligente',
	'fpd_response_errors': 'Erori de driver recomandate',
	'fpd_response_warnings': 'Avertismente de driver recomandate',
	'catalyst_service_bad_request': 'Cerere greşită',
	'catalyst_service_unkown_Id': 'A fost găsit ID de cerere necunoscut',
	'catalyst_service_internal_server_error': 'Eroare de server internă',
	'catalyst_service_generic_error': 'Eroare de serviciu Catalyst',
	'catalyst_service_error': 'Acest serviciu nu este disponibil în prezent',
	'propLegendPosition': 'Poziţie legendă',
	'propLeft': 'Stânga',
	'propRight': 'Dreapta',
	'propTop': 'Sus',
	'propBottom': 'Jos',
	'propNone': 'Fără',
	'propLegendDisplay': 'Afişare legendă',
	'targetThicknessPlaceHolder': '%{min} la %{max}',
	'targetThicknessErrorMsg': 'Introduceţi un număr întreg între %{min} şi %{max}.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Driver-e (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'selectate)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Resetare la valorile implicite',
	'possibelKeyDriver_AddNewDrivers': 'Adăugare mai multe driver-e',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Căutare pentru adăugare mai multe driver-e',
	'possibleKeyDrivers_MaxPossibleReached': 'Deselectaţi unele driver-e pentru adăugare sau selectaţi altele',
	'possibleKeyDrivers_Recommended': 'Recomandate',
	'visRecommendedTypes': 'Tipuri recomandate de vizualizare',
	'visRecommender_smartsfailure': 'în prezent nu sunt disponibile recomandări pentru vizualizare',
	'visMore': 'Mai multe...',
	'visMoreTooltip': 'Mai multe vizualizări',
	'visOtherTypes': 'Alte tipuri de vizualizări',
	'visChange': 'Modificare vizualizare',
	'automaticTypeCaption': 'Automat',
	'propVisType': 'Tipuri de vizualizare',
	'dlg_loading': 'Încărcare...',
	'snippetListChartCaption': 'Listă de snippet-uri',
	'convoClusterChartCaption': 'Cluster de conversaţie',
	'areaChartCaption': 'Suprafaţă',
	'barChartCaption': 'Bară',
	'columnChartCaption': 'Coloană',
	'stackedbarChartCaption': 'Bară suprapusă',
	'stackedcolumnChartCaption': 'Coloană suprapusă',
	'bubbleChartCaption': 'Bulă',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'Analiză driver',
	'scatterChartCaption': 'Prin puncte',
	'lineChartCaption': 'Linie',
	'pointChartCaption': 'Punct',
	'heatChartCaption': 'Hartă termică',
	'bulletChartCaption': 'Marcator',
	'waterfallChartCaption': 'Cascadă',
	'radarChartCaption': 'Radar',
	'boxplotChartCaption': 'Desen casetă',
	'pieChartCaption': 'Radială',
	'mapChartCaption': 'Hartă',
	'radialBarChartCaption': 'Radial',
	'compositeChartCaption': 'Linie şi coloană',
	'wordCloudChartCaption': 'Nor de cuvinte',
	'networkChartCaption': 'Reţea',
	'relationshipNetworkChartCaption': 'Reţea de ralaţii',
	'treemapChartCaption': 'Hartă arbore',
	'packedBubbleChartCaption': 'Bulă împachetată',
	'hierarcicalPackedBubbleChartCaption': 'Bulă ierarhie',
	'spiralChartCaption': 'Spirală',
	'decisionTreeChartCaption': 'Arbore de decizie',
	'legacyMapChartCaption': 'Mapare moştenire',
	'sunburstChartCaption': 'Explozie solară',
	'visUsageComparison': 'Comparaţie',
	'visUsageRelationships': 'Relaţii',
	'visUsageTrend': 'Tendinţă',
	'visUsagePartsToWhole': 'Părţi - întreg',
	'visUsageGeospatial': 'Geospaţială',
	'visUsageAdvanced': 'Analize avansate',
	'visUsageTablesAndSummary': 'Tabele şi sumare',
	'visUsageSocialInsights': 'Insight-uri sociale',
	'visUsageOther': 'Altul',
	'autoBinActionText': 'Grupare automată',
	'filterAutobinActionText': 'Filtrare bin-uri',
	'memberCalculationActionText': 'Calcul pe membri',
	'toolbarActionCalculation': 'Create calcul',
	'toolbarActionEditCalculation': 'Editare calcul',
	'topBottomRankLabel': 'Rang (%{label})',
	'toolbarDeleteFilterActionText': 'Înlăturare filtru',
	'toolbarActionTopKeyDrivers': 'Afişare driver-e',
	'toolbarActionCustomGroup': 'Grup personalizat',
	'canNotCreateCustomGroup': 'Nu putem crea acest grup personalizat.',
	'aria_label_datatable': 'Tabel de date',
	'summaryCaption': 'Sumar',
	'MeasuresCaption': 'Măsuri',
	'MeasuresGroupCaption': 'Grup de măsuri (%{count})',
	'ValuesCaption': 'Valori',
	'turnInsightsOn': 'Activare insight-uri',
	'turnInsightsOff': 'Dezactivare insight-uri',
	'decisionRules': 'Reguli',
	'decisionTree': 'Diagramă arbore',
	'decisionSunburst': 'Explozie solară arbore',
	'switchToDecisionRules': 'Comutare la reguli de decizie',
	'switchToDecisionTree': 'Comutare la arborele de decizie',
	'data_group_less_then': 'mai mic decât %{rangeTo}',
	'data_group_to': '%{rangeFrom} la < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} şi peste',
	'nullValueContent': '(nicio valoare)',
	'sum': 'Sumă',
	'count': 'Numărare',
	'countdistinct': 'Număr distinct',
	'avg': 'Mediu',
	'min': 'Minim',
	'max': 'Maxim',
	'automatic': 'Personalizat',
	'variance': 'Variaţie',
	'stddev': 'Deviere standard',
	'median': 'Median',
	'calculated': 'Calculat',
	'none': 'Fără',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': 'Valori prompt',
	'inputLabelPrompt': 'Valoare',
	'inputPlaceholderPrompt': 'Introducere valoare',
	'inputInvalidText': 'Intrare invalidă pentru tipul %{dataType}',
	'unSupportedPrompt': 'Prompt nesuportat',
	'missingDataSource': 'Nu a putut fi găsită sursa de date corectă.',
	'unSupportedPromptType': 'Scenariul de prompturi nu este suportat curent.',
	'preAggregateLabel': 'Aplicaţi valorile prompt din sursa de date',
	'postAggregateLabel': 'Aplicaţi valorile prompt în raport',
	'preAggregateText': 'Intervalul utilizează valorile din sursa de date, nu valorile afişate în tabloul de bord.',
	'defaultAggregation_count': 'Numărare',
	'defaultAggregation_countdistinct': 'Număr distinct',
	'defaultAggregation_max': 'Maxim',
	'defaultAggregation_min': 'Minim',
	'defaultAggregation_avg': 'Mediu',
	'defaultAggregation_sum': 'Sumă',
	'defaultAggregation_auto': 'Automat (%{aggregationType})',
	'keydriver_average': 'Media generală',
	'keydriver_up_down': 'Grupurile evidenţiate cu medii mici sau mari au mai mult impact asupra ţintei. Grupurile cu medii neobişnuit de mici sau mari au cel mai puternic impact.',
	'keydriver_different': 'Grupurile evidenţiate au distribuţii care diferă semnificativ faţă de distribuţia generală. Acest grupuri au mai mult impact asupra ţintei.',
	'topOperator': 'Sus',
	'bottomOperator': 'Jos',
	'topBottomFact': '%{operator} %{value}%{percent} după %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Ştergere număr primele sau ultimele',
	'deleteTopBottomPercent': 'Ştergere primele sau ultimele %',
	'topBottomTitle': 'Numai acest obiect',
	'deleteTopBottom': 'Ştergere număr primele sau ultimele',
	'editTopBottom': 'Editare număr primele sau ultimele',
	'editTopBottomCount': 'Editare număr primele sau ultimele',
	'editTopBottomPercent': 'Editare primele sau ultimele %',
	'ariaDeleteTopBottomCountLabel': 'Apăsaţi tasta DELETE pentru a şterge numărul pentru primele sau ultimele.',
	'ariaDeleteTopBottomPercentLabel': 'Apăsaţi tasta DELETE pentru a şterge primele sau ultimele %.',
	'ariaEditTopBottomCountLabel': 'Apăsaţi tasta ENTER pentru a edita numărul pentru primele sau ultimele.',
	'ariaEditTopBottomPercentLabel': 'Apăsaţi tasta ENTER pentru a edita primele sau ultimele %.',
	'ariaDeleteDrillStateLabel': 'Apăsaţi tasta ENTER pentru a edita numărul pentru primele sau ultimele.',
	'drillUpStateTitle': 'Drill up',
	'drillDownStateTitle': 'Drill down',
	'ariaEditTopBottomLabel': 'Apăsaţi tasta ENTER pentru a edita numărul pentru primele sau ultimele.',
	'ariaDeleteTopBottomLabel': 'Apăsaţi tasta DELETE pentru a şterge numărul pentru primele sau ultimele.',
	'allKeyDriversLabel': 'Automat (toate driver-ele)',
	'filter_drag_and_drop_single_dock': 'Trageţi şi plasaţi date aici pentru a filtra.',
	'filter_drag_and_drop_all_tabs': 'Trageţi şi plasaţi datele aici pentru a filtra toate filele.',
	'filter_drag_and_drop_current_tab': 'Trageţi şi plasaţi datele aici pentru a filtra această filă.',
	'filter_empty_consume_mode': 'Nu se aplică niciun filtru.',
	'filterClearAllItems': 'Curăţare toate filtrele',
	'filterDeleteAllItems': 'Ştergere toate filtrele',
	'filterDockChevronLeft': 'Defilaţi prin date',
	'filterDockChevronRight': 'Defilaţi prin date',
	'filterIconLabel_Single': 'Filtre',
	'filterIconLabel_Global': 'Toate filele',
	'filterIconLabel_Tab': 'Această filă',
	'filterIconTooltip_Single': 'Filtre',
	'filterIconTooltip_Global': 'Filtre pentru toate filele',
	'filterIconTooltip_Tab': 'Filtre pentru această filă',
	'filterDropZoneTooltip_Single': 'Filtrare zonă de plasare',
	'filterDropZoneTooltip_Global': 'Filtrare zonă de plasare pentru toate filele',
	'filterDropZoneTooltip_Tab': 'Filtrare zonă de plasare pentru această filă',
	'filterOverflowMenu': 'Mai multe',
	'expand': 'Expandare',
	'collapse': 'Restrângere',
	'filterDockItemNameAriaLabel': 'Apăsaţi enter pentru a lansa dialogul de filtru şi definiţi filtrul.',
	'filterItemCanvasMove': 'Adăugare la canava',
	'filterItemDelete': 'Ştergere filtru',
	'filterInvertRange': 'totul exceptând: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': 'Nu după %{from}',
	'filter_date_after': 'După %{from}',
	'filter_date_before_except': 'Nu înainte de %{to}',
	'filter_date_before': 'Înainte de %{to}',
	'filter_date_between_except': 'Nu între %{from}-%{to}',
	'filter_date_between': 'Între %{from}-%{to}',
	'filterValueSeparator': ',',
	'filterAll': 'Toate',
	'filter': 'Filtru',
	'filterExcept': 'exceptând %{values}',
	'filterDockToolbarButtonLabel': 'Doc de filtru',
	'navigateTitle': 'Navigare la',
	'navigateSelectColumn': 'Selectarea unei coloane',
	'navigateSelectPath': 'Selectare cale de navigare',
	'current_nav_group': 'Grupul de navigare curent este %{navigation_group_name}',
	'next': 'Următor',
	'previous': 'Anterior',
	'multiselectMsg': '%{count} selectate',
	'errMsgFilterItemMissingTitle': 'Valorile de filtrare %{itemName} nu pot fi încărcate, deoarece aceste valori nu sunt disponibile cu acest set de date',
	'errMsgFilterItemGenericTitle': 'Valorile de filtrare nu au putut fi încărcate',
	'textFilterItemsNotFound': 'Nu sunt disponibile articole.',
	'nullValueLabel': '(necompletat)',
	'filterConditionLabel': 'Condiţie de filtrare',
	'filter_includesAll': 'Include tot',
	'filter_allMembersOfSet': 'Toţi membrii din set',
	'modelFilter': 'Filtru',
	'filtersTitle': 'Proprietăţi de filtru',
	'search': 'Căutare',
	'clearTextFilterValue': 'Curăţare',
	'invertFilterSelection': 'Inversare',
	'modellingLoading': 'Încărcare...',
	'searchAll': 'Găsire toate coloanele',
	'toolbarActionPossibleKeyDrivers': 'Editare domeniu',
	'toolbarActionPossibleKeyDriversSubTitle': 'Trageţi din stânga articolele care trebuie să fie luate în considerare în diagrama de analiză a driver-elor',
	'toolbarActionSort': 'Sortare',
	'toolbarActionSortAscending': 'Crescător',
	'toolbarActionSortDescending': 'Descrescător',
	'toolbarActionSortAuto': 'Automat (%{sortOrder})',
	'toolbarActionSortCustom': 'Personalizat',
	'toolbarActionFormat': 'Formatare date',
	'toolbarActionFormatText': 'Formatare date (text)',
	'toolbarActionFormatAbbreviation': 'Abreviere',
	'toolbarActionFormatNone': 'Automat',
	'toolbarActionFilter': 'Filtru',
	'toolbarActionTopBottom': 'Vârf sau sfârşit',
	'toolbarActionRmvShape': 'Înlăturare formă',
	'toolbarActionToggleShapeDrop': 'Formă infografic',
	'toolbarActionToggleShapeDropTitle': 'Creare infografic',
	'toolbarActionToggleShapeDropText': 'Trageţi o formă în acest câmp pentru a crea un infografic.',
	'toolbarActionAggregationType': 'Sumarizare',
	'toolbarDeleteActionText': 'Înlăturare coloană',
	'toolbarTextActionText': 'Text stil',
	'toolbarActionFilterLocalKeepSelected': 'Păstrare',
	'toolbarActionFilterLocalExcludeSelected': 'Excludere',
	'toolbarActionFilterAllKeepSelected': 'Filtru',
	'toolbarActionSimpleCalculation': 'Calcul simplu',
	'toolbarActionDrillBack': 'Înapoi',
	'toolbarActionDrillUp': 'Drill up',
	'toolbarActionDrillDown': 'Drill down',
	'toolbarActionJumpTo': 'Drill through',
	'toolbarActionNavigate': 'Navigare',
	'toolbarActionCreateFilterGroup': 'Creare conexiune nouă',
	'toolbarActionDisconnectFilterGroup': 'Întrerupere toate legăturile',
	'toolbarActionLinkFilterGroup': 'Adăugare la o conexiune existentă',
	'toolbarActionLassoSelect': 'Selectare unealtă',
	'toolbarActionRefreshDeveloperWidget': 'Reîmprospătare',
	'textFontFamilySubClassHairline': 'Linie fină',
	'textFontFamilySubClassThin': 'Subţire',
	'textFontFamilySubClassThinItalic': 'Cursiv subţire',
	'textFontFamilySubClassExtraLight': 'Extra-luminos',
	'textFontFamilySubClassExtraLightItalic': 'Cursiv extra-luminos',
	'textFontFamilySubClassLight': 'Luminos',
	'textFontFamilySubClassLightItalic': 'Cursiv luminos',
	'textFontFamilySubClassRegular': 'Obişnuit',
	'textFontFamilySubClassRegularItalic': 'Cursiv obişnuit',
	'textFontFamilySubClassItalic': 'Cursiv',
	'textFontFamilySubClassMedium': 'Mediu',
	'textFontFamilySubClassMediumItalic': 'Cursiv mediu',
	'textFontFamilySubClassHeavy': 'Greu',
	'textFontFamilySubClassHeavyItalic': 'Cursiv greu',
	'textFontFamilySubClassDemiBold': 'Semi-aldin',
	'textFontFamilySubClassDemiBoldItalic': 'Cursiv semi-aldin',
	'textFontFamilySubClassBold': 'Aldin',
	'textFontFamilySubClassBoldItalic': 'Cursiv aldin',
	'textFontFamilySubClassExtraBold': 'Extra-aldin',
	'textFontFamilySubClassExtraBoldItalic': 'Cursiv extra-aldin',
	'textFontFamilySubClassBlack': 'Negru',
	'textFontFamilySubClassBlackItalic': 'Cursiv negru',
	'textFontFamilySubClassStencil': 'Stencil',
	'dlg_ascending': 'crescător',
	'dlg_descending': 'descrescător',
	'dlg_custom': 'personalizat',
	'dlg_none': 'fără',
	'dlg_hierarchy': 'ierarhie',
	'dlg_namedSet': 'set numit',
	'dlg_rank': 'rank',
	'visualizationLabel': 'Vizualizare',
	'chartLabel': 'Diagramă %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Apăsaţi F12 pentru a naviga în widget',
	'f10KeyDescription': 'Apăsaţi F10 pentru a lansa vizualizarea de focalizare widget',
	'playButtonLabel': 'Redare',
	'dataPlayerValueListLabel': 'Valori cititor de date',
	'localFilterTitle': 'Numai acest obiect',
	'globalFilterTitle': 'Toate obiectele',
	'deleteFilter': 'Ştergere filtru',
	'editFilter': 'Editare filtru',
	'ariaEditFilterLabel': 'Apăsaţi Enter pentru a edita filtrul.',
	'ariaDeleteFilterLabel': 'Apăsaţi tasta DELETE pentru a şterge filtrul.',
	'measureFilterBetween': 'Între %{lowerBound} şi %{upperBound}',
	'measureFilterNotBetween': 'Nu între %{lowerBound} şi %{upperBound}',
	'dimFilterIn': 'Include: %{in}',
	'dimFilterNotIn': 'Exclude: %{out}',
	'gtFilter': 'După %{lowerBound}',
	'ltFilter': 'Înainte de %{upperBound}',
	'ariaEditPrompt': 'Apăsaţi tasta ENTER pentru a schimba valoarea promptului',
	'dataPointFilterTitle': 'Puncte date',
	'dataPointFilterIncludeSummary': '%{valueCount} puncte de date incluse',
	'dataPointFilterExcludeSummary': '%{valueCount} puncte de date excluse',
	'widgetFiltersLabel': 'Filtre widget',
	'coachMarkTitleSpiralTarget': 'Editare domeniu',
	'coachMarkContentSpiralTarget': 'Aici puteţi accesa şi modifica selecţia de driver-e pentru ţinta dumneavoastră.',
	'srILVTreeLabel': 'Listă',
	'geomapUnrecognizedLocations': 'Locaţii nerecunoscute:',
	'geomapAmbiguousLocations': 'Regiuni ambigue:',
	'visualizationNotifications': 'Notificări vizualizare:',
	'dataNotifications': 'Notificări de date:',
	'autobinSuggestion': 'Activare grupare automată',
	'LIVE_empty_visualization_hint_title': 'Construiţi o vizualizare proprie',
	'LIVE_empty_visualization_hint_description': 'Trageţi datele aici sau pe câmpuri.',
	'LIVE_slots_required_field_description': '%{asterisk} indică un câmp necesar',
	'LIVE_slots_drag_and_drop_description': 'Trageţi şi plasaţi datele în câmpurile de deasupra, pentru a construi şi filtra vizualizarea.',
	'dwErrorLoadingAvailableVisualizations': 'Nu putem încărca definiţiile de vizualizare disponibile',
	'moreDataIndicator': 'Datele dumneavoastră au fost decupate la %{threshold} articole. Aplicaţi un filtru pentru a afişa mai puţin.',
	'nonCtxTopBottomInvalid': 'Pentru tabele încrucişate, nu este suportată definirea unei reguli de afişare a primelor sau ultimelor elemente fără un context. A fost înlăturată din această vizualizare de tabel încrucişat.  Redefiniţi regula pentru una sau mai multe categorii în contextul %{columnName}.',
	'dwErrorLoadingVisualizationNotFound': 'Obiectul nu poate fi încărcat, deoarece lipseşte o definiţie de vizualizare.',
	'dwErrorLoadingVisualizationListNotFound': 'Nu putem încărca vizualizarea.',
	'dwErrorRunningQuery': 'Nu pot fi extrase datele din setul de date %{datasetName}.',
	'dwErrorGeoData': 'Avem probleme cu afişarea datelor geografice într-o hartă. Vă rugăm să alegeţi alt tip de vizualizare.',
	'dwPromptSignonCancelWarning': 'Datele pentru această vizualizare nu sunt disponibile. Vă rugăm să furnizaţi acreditările corecte.',
	'dwErrorMissingDataset': 'Vizualizarea nu poate fi încărcată, deoarece nu este disponibil setul său de date asociat "%{datasetName}".',
	'dwErrorRenderingVisualization': 'Nu putem încărca  această vizualizare.',
	'dwErrorVisualizationTooSmall': 'Vizualizarea este prea mică pentru a afişa datele pe care le conţine. Faceţi vizualizarea mai mare sau limitaţi datele pe care le conţine.',
	'errorSourceNotFound': 'Vizualizarea nu poate fi încărcată, deoarece nu este disponibilă sursa sa asociată "%{sourceName}".',
	'errorActionNotSupported': 'Această acţiune nu este suportată pentru sursa de date "%{sourceName}".',
	'errorMeasureNotSupportedOnMultiEdges': 'Vizualizarea are măsuri pe mai multe margini, care nu mai sunt suportate. Plasaţi măsurile pe o singură margine.',
	'errorExceedAllowableValue': 'Numărul de celule estimat depăşeşte valoarea permisă, de 100000. Aplicaţi filtrarea seturilor proiectate pentru a reduce numărul de celule.',
	'propScaleLabel': 'Cantitatea de pictograme',
	'propScaleDescription': 'Selectaţi cantitatea de pictograme',
	'propScaleFew': 'Scăzut',
	'propScaleDefault': 'Implicit',
	'propScaleMany': 'Nivel ridicat',
	'lastRefresh': 'Ultima reîmprospătare: Acum %{timeInterval}',
	'widgetTimer': 'Cronometru Widget',
	'datasetItemsUnavailable': 'Unele articole din setul de date utilizate în această vizualizare nu sunt disponibile.',
	'datasetItemUnavailable': 'Acest articol de set de date nu este disponibil',
	'retry': 'Reîncercare',
	'widgetConditionalFormatLabel': 'Comutaţi controalele de format condiţional',
	'widgetConditionalFormatTitle': 'Editare culoare formatare condiţională',
	'crosstabName': 'Tabel încrucişat',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'N/A',
	'summaryLabel': '%{label} cu valoarea %{value}',
	'infographicLabel': '%{label} cu valoarea %{value}',
	'warning': 'Avertisment',
	'swapRowsAndColumns': 'schimbarea rândurilor şi coloanelor între ele',
	'hideSummariesLabel': 'Ascundere sumare',
	'showSummariesLabel': 'Afişare sumare',
	'hideRowColumn': 'Ascundere',
	'showAllRowColumn': 'Afişare tot',
	'dataAssetPropertiesLabel': 'Proprietăţi de vizualizare',
	'evAdd': 'Adăugarea unei coloane',
	'evCollapse': 'Restrângere',
	'evColumns': 'Coloane',
	'evLocalFilters': 'Filtre locale',
	'evExpand': 'Expandare',
	'evFilterTooltip': 'Filtru',
	'missingColumn': 'Lipsă: %{columnLabel}',
	'missingFiltering': 'Filtre sau coloane lipsă:',
	'missingDataItem': 'Articolul de date referit "%{dataItemId}" nu poate fi găsit în widget.',
	'heatByLabel': 'Căldură după',
	'toolbarChangeVisualization': 'Modificare vizualizare',
	'modellingRelatedTablesNoneFound': 'Nu au fost găsite tabele înrudite',
	'processing': 'Procesare...',
	'errorCellWarning': 'Unele valori de sumar nu au putut fi calculate.',
	'aggregateTypeToggler': 'Afişare tip agregare',
	'maxColumnsExceeded': 'A fost depăşit numărul maxim de coloane. %{columns} au fost abandonate.',
	'unboundColumns': 'Nu pot fi utilizate următoarele coloane: %{columns}.',
	'unboundColumn': 'Nu poate fi utilizată următoarea coloană: %{columns}.',
	'recommendRequestFailed': 'Cererea de recomandare a eşuat. Contactaţi administratorul.',
	'visualizationDoesNotSupportOLAP': 'Nu putem crea această vizualizare care este bazată pe o sursă de date OLAP. Vă rugăm utilizaţi o altă sursă de date suportată.',
	'showDataBehindVizLabel': 'Afişare date',
	'showDataBehindVizNotSupportedLabel': 'Afişarea datelor nu este suportată pentru acest tip de vizualizare',
	'exploreData': 'Explorare ...',
	'newExplore': 'Explorare nouă',
	'thumbnails_error_fetching': 'Eroare la aducerea miniaturilor',
	'loadedThumbnailImage': 'Imagine miniatură vizualizare %{visType} încărcată',
	'autobinAxisLabel': 'grupuri',
	'recommended_visualizations': 'Vizualizări recomandate',
	'all_visualizations': 'Toate vizualizările',
	'edit': 'Editare',
	'selectTargetDialogTitle': 'Selectare ţintă drill-through',
	'noTargetInCM': 'Nu poate fi găsită ţinta drill-through',
	'errorDrillDefinition': 'Ceva a mers prost în timp ce aţi adăugat sau editat definiţia de drill-through.',
	'errorDrillToTarget': 'A apărut o eroare pentru drill la "%{targetName}"',
	'drillThroughMappingViewLabel': 'Alocaţi coloane din tabloul dumneavoastră de bord la prompturile raportului ţintă',
	'drillthroughScopeRadioLabel': 'Această definiţie se aplică pentru:',
	'drillthroughScopeRadioOptionVisualization': 'Numai această vizualizare',
	'drillthroughScopeRadioOptionConnection': 'Vizualizările din aceeaşi conexiune care utilizează aceeaşi sursă de date',
	'drillthroughScopeRadioOptionDashboard': 'Orice vizualizare pe %{perspective} care utilizează aceeaşi sursă de date',
	'drillThroughParametersColumnTitle': 'Prompturi "%{targetName}":',
	'drillThroughMetadataColumnTitle': 'Coloane de date "%{boardName}":',
	'drillThroughDefinitionNoParameter': 'Ţinta drill-through nu are prompturi.',
	'drillThroughDefinitionErrorQueryingReport': 'Corectaţi problema cu raportul ţintă şi apoi încercaţi din nou să creaţi definiţia drill-through.',
	'drillThroughDefinitionErrorDlgTitle': 'Ceva nu a mers bine',
	'dlg_back': 'Deplasare înapoi',
	'dlg_close': 'Închidere',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Anulare',
	'dlg_apply': 'Aplicare',
	'dlg_create': 'Creare',
	'dlg_done': 'Gata',
	'drillthrough_unsaveMsg': 'Continuaţi fără să salvaţi "%{name}"?',
	'drillthrough_jumpTo': 'Definiţie drill-through: %{name}',
	'drillthrough_jumpToLabel': 'Drill through',
	'drillthrough_manage': 'Gestionare...',
	'drillthrough_addNewTarget': 'Adăugare definiţie drill-through nouă',
	'drillthrough_manageJumpPaths': 'Gestionare definiţii drill-through',
	'drillthrough_manageJumpPaths_edit': 'Editare "%{name}"',
	'drillthrough_manageJumpPaths_delete': 'Ştergere "%{name}"',
	'drillthrough_manageAddAnotherTarget': 'Adăugare altă definiţie drill-through',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Confirmare ştergere',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'Sunteţi sigur că vreţi să ştergeţi drill-through-ul "%{name}"?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Nume drill-through duplicat',
	'drillthrough_definitionMessage': 'Drill-through-ul "%{name}" există deja. Furnizaţi alt nume.',
	'drillthrough_jumpToTarget_notFound': 'Nu a fost găsită ţinta pentru drill-through-ul "%{name}"',
	'drillThroughDefinitionNoParameterSubTitle': 'Nu va fi transmis niciun context către raportul ţintă.',
	'drillthrough_titleLabel': 'Nume',
	'drillthrough_create_dialogTitle': 'Creare definiţie drill-through',
	'drillthrough_edit_dialogTitle': 'Editare definiţie drill-through',
	'drillthrough_subTitle': 'Contextul de vizualizare din sursa dumneavoastră este utilizat pentru a filtra ţinta %{perspective}.',
	'drillthrough_selectColumn': 'Selectarea unei coloane',
	'noPrompt': 'Nu există prompturi',
	'promptDialog': 'Dialog prompt %{promptType}',
	'formatAutoDescription': 'Specifică automat formatul moştenit de la sursa de date sau vizualizare.',
	'formatDefaultDescription': 'Implicit specifică formatul moştenit de la sistem',
	'createCustomGroupAction': 'Creare grup de date',
	'removeCustomGroupAction': 'Înlăturare grup de date',
	'editCustomGroupAction': 'Editare grup de date',
	'renameCustomGroupAction': 'Redenumire grup de date',
	'createCustomGroupErrorToast': 'Grupul dumneavoastră de date nu a putut fi creat.',
	'removeCustomGroupErrorToast': 'Grupul dumneavoastră de date nu a putut fi înlăturat.',
	'editCustomGroupErrorToast': 'Grupul dumneavoastră de date nu a putut fi editat.',
	'renameCustomGroupErrorToast': 'Grupul dumneavoastră de date nu a putut fi redenumit.',
	'customGroupLabel': 'Creare grup de date',
	'ungroupCustomGroupLabel': 'Degrupare',
	'renameCustomGroupLabel': 'Redenumire',
	'createCustomGroupLabel': 'Creare',
	'customGroupingLabel': '%{columnLabel} (grup)',
	'createCustomSort': 'Creare sortare personalizată',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': 'Selectaţi articolele disponibile şi apoi reordonaţi-le pentru a crea o sortare personalizată.',
	'availableItems': 'Articole disponibile',
	'selectAll': 'Selectare tot',
	'customSortOrder': 'Ordine sortare personalizată',
	'selectAvailableItemsDesc': 'Selectaţi articolele disponibile şi apoi reordonaţi-le aici.',
	'moveToTop': 'Mutare în sus',
	'clear': 'Curăţare',
	'sortRemainingItemsBy': 'Sortare articole rămase după',
	'removeAll': 'Înlăturare tot',
	'resetTooltip': 'Vor fi înlăturate toate articolele din lista %{customSortOrder}. Iar lista derulantă %{sortRemainingItemsBy} va reveni la valoarea implicită.',
	'manyItemsWarning': 'Selectarea unui număr mare de articole poate afecta performanţa tabloului dumneavoastră de bord.',
	'manyItemsSelected': 'Au fost selectate peste %{maxItems} articole şi aceasta poate afecta performanţa tabloului dumneavoastră de bord.',
	'somethingWentWrong': 'Vai. Ceva nu este în regulă.',
	'tryAgain': 'Încercaţi din nou',
	'customSortLabel': 'Sortare personalizată',
	'applyError': 'Nu se poate aplica %{action}.',
	'searchReturnedNoResults': 'Hm, căutarea dumneavoastră nu a returnat niciun rezultat.',
	'extVisSystem': 'De sistem',
	'extVisCustom': 'Personalizat',
	'customVisTestVisualization': 'Vizualizare test',
	'extVisCustomVisPreview': 'previzualizare',
	'extVisCustomPreviewWidgets': 'Widget-uei de dezvoltator',
	'extVisCustomVVisualization': 'Vizualizare',
	'extVisCustomVisuals': 'Imagini personalizate',
	'noPermissionToManage': 'Nu aveţi permisiunea de a gestiona vizualizări personalizate.',
	'extVisCustomUpdate': 'Actualizare',
	'extVisCustomDelete': 'Ştergere',
	'extVisNoCustomVisuals': 'Nicio vizualizare personalizată',
	'extVisNoCustomVisualsMsg': 'Nu există curent vizualizări personalizate în organizaţia dumneavoastră.',
	'extVisAddCustomVisual': 'Adăugare vizualizare personalizată',
	'extVisNoCustomVisualsAdminMsg': 'Nu există curent vizualizări personalizate. Adăugaţi una ca să începeţi.',
	'extVisNoSDKConnection': 'Nu a fost creată nici o conexiune la fişierul local',
	'extVisNoSDKPreviewMsg': 'Pentru a previzualiza vizualizările dumneavoastră, vă rugăm să stabiliţi o conexiune.',
	'extVisMore': 'Mai multe',
	'extVisDeleteDialogTitle': 'Ştergere vizualizare personalizată',
	'extVisDeleteDialogBody': 'Sunteţi sigur că doriţi să ştergeţi această vizualizare personalizată? Acest lucru ar putea fi utilizat de alte tablouri de bord şi rapoarte.',
	'extVisDeleteConfirmation': 'Vizualizarea dumneavoastră personalizată a fost ştearsă.',
	'extVisDeleteError': 'Nu a putut fi ştearsă vizualizarea dumneavoastră personalizată. %{msg}',
	'extVisCloseToast': 'Închidere acum',
	'extVisAdd': 'Vizualizarea dumneavoastră personalizată a fost adăugată cu succes.',
	'extVisAddError': 'Nu a putut fi adăugată vizualizarea dumneavoastră personalizată. %{msg}',
	'extVisUpdate': 'Vizualizarea dumneavoastră personalizată a fost actualizată cu succes.',
	'extVisUpdateError': 'Nu a putut fi actualizată vizualizarea dumneavoastră personalizată. %{msg}',
	'extVisAddProgress': 'Import %{name}',
	'extVisUpdateProgress': 'Actualizare %{name}',
	'extPermissionTitle': 'Acces restricţionat sau vizualizarea personalizată a fost ştearsă',
	'extPermissionBody': 'Această vizualizare personalizată nu poate fi vizualizată deoarece fie a fost ştearsă, fie are accesul restricţionat.',
	'customVizSaveWarning': 'Vizualizările dumneavoastră personalizate nu pot fi salvate. Ele nu au fost importate.',
	'schematicTestCaption': 'Schemă test',
	'schematicServiceRequestError': 'Eroare serviciu schemă',
	'extVisPreviewMessage': 'Aceasta este o previzualizare. Vizualizarea încă nu a fost adăugată la produs.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Nedefinit',
	'kpiDefaultTargetLabel': 'Ţintă',
	'kpiNonNumericTarget': 'Valoarea ţintă trebuie să fie un număr.',
	'kpiManualTargetSlotFilled': 'Valoarea aplicată în câmp',
	'kpiAutoValueSize': 'Automat',
	'kpiUnableDrawSparklineLabel': 'Nu a putut fi desenată diagrama sparkline',
	'kpiUnableDrawSparklineInfo': 'O diagramă sparkline necesită cel puţin două puncte în timp. Modificaţi datele sau ajustaţi filtrele pentru a vedea diagrama sparkline.',
	'conditionalFormattingTextColor': 'Culoare text',
	'suppression': 'Suprimare',
	'suppressNone': 'Fără',
	'suppressRowsAndColumns': 'Rânduri şi coloane',
	'suppressRows': 'Rânduri',
	'suppressColumns': 'Coloane',
	'enableSuppression': 'Activare suprimare',
	'disableSuppression': 'Dezactivare suprimare',
	'loadVisDefinitionError': 'Nu poate fi încărcată definiţia pentru vizualizarea %{id}',
	'emptyVisualization': 'Vizualizare goală',
	'expandCollapse': 'Expandare şi restrângere',
	'expandBtnLabel': 'Expandare',
	'collapseBtnLabel': 'Restrângere',
	'prop_sizeInputNonNumericValue': 'Valoarea trebuie să fie un număr.',
	'prop_sizeValueShouldBeHigher': 'Valoarea trebuie să fie mai mare decât %{value}.',
	'fontPropLabel': 'Familie de fonturi',
	'fontSizePropLabel': 'Mărime font',
	'sectionItemAxisTitle': 'Titlu axă articole',
	'sectionItemAxisLabel': 'Etichetă axă articole',
	'sectionValueAxisTitle': 'Titlu axă valori',
	'sectionValueAxisLabel': 'Etichetă axă valori',
	'styletext-widget.legend': 'Legendă',
	'styletext-itemAxis.ticks.labels': 'Etichete de axă',
	'styletext-valueAxis.title': 'Titluri de axă',
	'styletext-itemAxis.title': 'Titluri de axă',
	'styletext-labels': 'Etichete de date',
	'styletext-valueAxis.line.title': 'Titluri de linie',
	'styletext-cellValue': 'Valori',
	'styletext-values': 'Valori',
	'styletext-rowHeading': 'Titluri de rând',
	'styletext-columnHeading': 'Titluri de coloană',
	'fontFamily': 'familie',
	'fontSize': 'mărime',
	'visExportFileName': 'Vizualizare',
	'ds-missingDataSet': 'Nu a putut fi găsit setul de date. Asiguraţi-vă că setul de date a fost creat cu succes.',
	'ds-missingDashboardId': 'Salvaţi tabloul de bord înainte de a crea setul de date.',
	'ds-unsupportedDataSourceType': 'Tipul de sursă de date %{type} nu este suportat.',
	'dataCache': 'Cache date',
	'dataCache_on': 'Activat',
	'dataCache_off': 'Fără cache',
	'dataCache_auto': 'Automat',
	'queryOptimization': 'Optimizare interogare '
});
